module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_16.bcd24191.jpg";